import { i18n } from "@/boot/i18n";
import { ACTIVATION, VISUALIZATION, SHOW_WIDGET, EXHIBITION_MODES } from "@/consts/widget";

export const getWidgetDefaultState = () => ({
  name: "",
  survey_uuid: null,
  enabled: false,
  activation: ACTIVATION.MANUAL,
  deactivateByResponses: false,
  deactivateByDate: false,
  responses: 0,
  start_date: null,
  end_date: null,
  visualization: VISUALIZATION.IMMEDIATE,
  delay: 0,
  show_widget: SHOW_WIDGET.ALWAYS,
  days_after_response: 0,
  days_after_decline: 0,
  minimized: false,
  survey_colors: true,
  primary_color: "#FFFFFF",
  secondary_color: "#2E345A",
  hosts: [
    {
      host_name: "",
      survey_uuid: ""
    }
  ],
  exhibition: EXHIBITION_MODES.BOX,
  thanks_message: {
    pt_BR: i18n.t("widget.default_thanks.pt_BR"),
    en_US: i18n.t("widget.default_thanks.en_US"),
    es_ES: i18n.t("widget.default_thanks.es_ES")
  }
});

export default {
  widget: {},
  widgets: null
};
